import { Dayjs } from "dayjs";

import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { PaymentsClient } from "../../parentApi";

const client = new PaymentsClient(app_uri, axiosClient());

export async function downloadStatementOfEntitlement(
  customerAccountId: number,
  startDate: Dayjs,
  endDate: Dayjs
): Promise<Blob> {
  const response = await client.getStatementOfEntitlement(customerAccountId, startDate, endDate);

  return response.data;
}
